import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import PolicyDBComponent from "./component";

export const PolicyDB = compose(protectedComponentHoc)(PolicyDBComponent);
